/**
 * @jsxRuntime classic
 * @jsx jsx
 */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { jsx } from '@emotion/react';
import { useIntl } from 'react-intl-next';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { Anchor, Inline, xcss } from '@atlaskit/primitives';
import messages from '../messages';
import { CustomDisclaimer } from './CustomDisclaimer';
var linkStyles = xcss({
  font: 'font.body.small',
  color: 'color.text.subtlest',
  textDecoration: 'none',
  ':visited': {
    color: 'color.text.subtlest'
  },
  ':hover': {
    color: 'color.text.subtlest',
    textDecoration: 'underline'
  }
});
export function FooterDisclaimer(_ref) {
  var disclaimer = _ref.disclaimer,
    appearance = _ref.appearance;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return disclaimer ? jsx(CustomDisclaimer, {
    disclaimer: disclaimer
  }) : jsx(Inline, {
    space: "space.050",
    alignBlock: "center"
  }, jsx(InfoIcon, {
    label: formatMessage(messages.infoIconLabel),
    primaryColor: "var(--ds-text-subtlest, #626F86)",
    size: "small"
  }), jsx(Anchor, {
    color: "color.text.subtlest",
    href: "https://www.atlassian.com/trust/atlassian-intelligence",
    xcss: linkStyles
  }, formatMessage(appearance === 'large' ? messages.disclaimerText : messages.disclaimerTextShort)));
}